/**
 * Converts a value to a JSON string, with special handling for BigInt, Set, and Map types.
 * @util
 * @param value - The value to convert to JSON
 * @param space - Optional number or string to use for indentation
 * @returns A JSON string representation of the value
 * @throws {TypeError} If the value contains circular references
 */
export function toJsonString(value, space) {
    if (value == null) {
        return 'null';
    }
    return JSON.stringify(value, serializeValue, space);
}
function serializeValue(_key, value) {
    switch (typeof value) {
        case 'bigint':
            return value.toString();
        case 'boolean':
        case 'number':
        case 'string':
        case 'undefined':
            return value;
        case 'function':
            return undefined;
        default:
            break;
    }
    if (value instanceof Set) {
        const result = [];
        for (const val of value) {
            result.push(val);
        }
        return result;
    }
    if (value instanceof Map) {
        const map = value;
        const result = [];
        for (const [key, val] of map.entries()) {
            result.push([key, val]);
        }
        return result;
    }
    return value;
}
//# sourceMappingURL=toJsonString.js.map